import React, { useMemo } from 'react';
import { cx } from '@emotion/css';
import { emptyContentStyle, label, prefix, small, large, medium } from "./emptyContent.style";
import useThemeProps from "../../hooks/useThemeProps";
import { columnCenter } from "../../styles/layout";
export var darkIcon = {
  large: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "44",
    viewBox: "0 0 72 44",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1998 34.65C71.1998 38.5988 63.4998 44 35.9998 44C7.39981 44 0.799805 38.5988 0.799805 34.65C0.799805 30.7012 16.5594 27.5 35.9998 27.5C55.4402 27.5 71.1998 30.7012 71.1998 34.65Z",
    fill: "#2D3446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5842 1.03972C22.8692 0.697734 23.2914 0.5 23.7366 0.5H48.2631C48.7082 0.5 49.1304 0.697734 49.4154 1.03972L59.6998 13.381V33.05H12.2998V13.381L22.5842 1.03972Z",
    fill: "#121927",
    stroke: "#526079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1997 15.2002C11.1997 14.3718 11.8713 13.7002 12.6997 13.7002H20.6416C22.0727 13.7002 23.3597 14.5715 23.8912 15.9003L24.834 18.2573C25.0618 18.8268 25.6134 19.2002 26.2267 19.2002H45.7727C46.386 19.2002 46.9376 18.8268 47.1654 18.2573L48.1082 15.9003C48.6397 14.5715 49.9267 13.7002 51.3578 13.7002H59.2997C60.1281 13.7002 60.7997 14.3718 60.7997 15.2002V33.5002C60.7997 35.9855 58.785 38.0002 56.2997 38.0002H15.6997C13.2144 38.0002 11.1997 35.9855 11.1997 33.5002V15.2002Z",
    fill: "#2D3446",
    stroke: "#526079"
  })),
  medium: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "40",
    viewBox: "0 0 64 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 31.5C64 35.0899 57 40 32 40C6 40 0 35.0899 0 31.5C0 27.9101 14.3269 25 32 25C49.6731 25 64 27.9101 64 31.5Z",
    fill: "#2D3446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7844 1.03972C20.0694 0.697734 20.4916 0.5 20.9367 0.5H43.0632C43.5084 0.5 43.9306 0.697734 44.2156 1.03972L53.5 12.181V30H10.5V12.181L19.7844 1.03972L19.4003 0.71963L19.7844 1.03972Z",
    fill: "#121927",
    stroke: "#526079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.5 13.1716 10.1716 12.5 11 12.5H17.7919C19.223 12.5 20.51 13.3713 21.0415 14.7001L21.7843 16.5571C22.0121 17.1266 22.5637 17.5 23.177 17.5H40.823C41.4363 17.5 41.9879 17.1266 42.2157 16.5571L42.9585 14.7001C43.49 13.3713 44.777 12.5 46.2081 12.5H53C53.8284 12.5 54.5 13.1716 54.5 14V30C54.5 32.4853 52.4853 34.5 50 34.5H14C11.5147 34.5 9.5 32.4853 9.5 30V14Z",
    fill: "#2D3446",
    stroke: "#526079"
  })),
  small: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "58",
    height: "36",
    viewBox: "0 0 58 36",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8002 28.35C57.8002 31.5809 51.5002 36 29.0002 36C5.6002 36 0.200195 31.5809 0.200195 28.35C0.200195 25.1191 13.0944 22.5 29.0002 22.5C44.906 22.5 57.8002 25.1191 57.8002 28.35Z",
    fill: "#2D3446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9846 1.03972C18.2696 0.697734 18.6918 0.5 19.1369 0.5H38.8634C39.3086 0.5 39.7308 0.697735 40.0158 1.03972L48.3002 10.981V26.95H9.7002V10.981L17.9846 1.03972Z",
    fill: "#121927",
    stroke: "#526079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80029 12.7998C8.80029 11.9714 9.47187 11.2998 10.3003 11.2998H15.9422C17.3733 11.2998 18.6603 12.1711 19.1918 13.4999L19.7346 14.8569C19.9624 15.4264 20.514 15.7998 21.1273 15.7998H36.8733C37.4866 15.7998 38.0382 15.4264 38.266 14.8569L37.8017 14.6712L38.266 14.8569L38.8088 13.4999C39.3403 12.1711 40.6273 11.2998 42.0584 11.2998H47.7003C48.5287 11.2998 49.2003 11.9714 49.2003 12.7998V26.4998C49.2003 28.9851 47.1856 30.9998 44.7003 30.9998H13.3003C10.815 30.9998 8.80029 28.9851 8.80029 26.4998V12.7998Z",
    fill: "#2D3446",
    stroke: "#526079"
  }))
};
export var lightIcon = {
  large: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "44",
    viewBox: "0 0 72 44",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1998 34.65C71.1998 38.5988 63.4998 44 35.9998 44C7.39981 44 0.799805 38.5988 0.799805 34.65C0.799805 30.7012 16.5594 27.5 35.9998 27.5C55.4402 27.5 71.1998 30.7012 71.1998 34.65Z",
    fill: "#F0F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5842 1.03972C22.8692 0.697734 23.2914 0.5 23.7366 0.5H48.2631C48.7082 0.5 49.1304 0.697734 49.4154 1.03972L59.6998 13.381V33.05H12.2998V13.381L22.5842 1.03972Z",
    fill: "white",
    stroke: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1997 15.2002C11.1997 14.3718 11.8713 13.7002 12.6997 13.7002H20.6416C22.0727 13.7002 23.3597 14.5715 23.8912 15.9003L24.834 18.2573C25.0618 18.8268 25.6134 19.2002 26.2267 19.2002H45.7727C46.386 19.2002 46.9376 18.8268 47.1654 18.2573L48.1082 15.9003C48.6397 14.5715 49.9267 13.7002 51.3578 13.7002H59.2997C60.1281 13.7002 60.7997 14.3718 60.7997 15.2002V33.5002C60.7997 35.9855 58.785 38.0002 56.2997 38.0002H15.6997C13.2144 38.0002 11.1997 35.9855 11.1997 33.5002V15.2002Z",
    fill: "#F9FAFB",
    stroke: "#E2E5E7"
  })),
  medium: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "40",
    viewBox: "0 0 64 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 31.5C64 35.0899 57 40 32 40C6 40 0 35.0899 0 31.5C0 27.9101 14.3269 25 32 25C49.6731 25 64 27.9101 64 31.5Z",
    fill: "#F0F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7844 1.03972C20.0694 0.697734 20.4916 0.5 20.9367 0.5H43.0632C43.5084 0.5 43.9306 0.697734 44.2156 1.03972L53.5 12.181V30H10.5V12.181L19.7844 1.03972L19.4003 0.71963L19.7844 1.03972Z",
    fill: "white",
    stroke: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.5 13.1716 10.1716 12.5 11 12.5H17.7919C19.223 12.5 20.51 13.3713 21.0415 14.7001L21.7843 16.5571C22.0121 17.1266 22.5637 17.5 23.177 17.5H40.823C41.4363 17.5 41.9879 17.1266 42.2157 16.5571L42.9585 14.7001C43.49 13.3713 44.777 12.5 46.2081 12.5H53C53.8284 12.5 54.5 13.1716 54.5 14V30C54.5 32.4853 52.4853 34.5 50 34.5H14C11.5147 34.5 9.5 32.4853 9.5 30V14Z",
    fill: "#F9FAFB",
    stroke: "#E2E5E7"
  })),
  small: /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "58",
    height: "36",
    viewBox: "0 0 58 36",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8002 28.35C57.8002 31.5809 51.5002 36 29.0002 36C5.60019 36 0.200195 31.5809 0.200195 28.35C0.200195 25.1191 13.0944 22.5 29.0002 22.5C44.906 22.5 57.8002 25.1191 57.8002 28.35Z",
    fill: "#F0F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9846 1.03972C18.2696 0.697735 18.6918 0.5 19.1369 0.5H38.8634C39.3086 0.5 39.7308 0.697735 40.0158 1.03972L48.3002 10.981V26.95H9.7002V10.981L17.9846 1.03972L17.605 0.723339L17.9846 1.03972Z",
    fill: "white",
    stroke: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80029 12.7998C8.80029 11.9714 9.47187 11.2998 10.3003 11.2998H15.9422C17.3733 11.2998 18.6603 12.1711 19.1918 13.4999L19.7346 14.8569C19.9624 15.4264 20.514 15.7998 21.1273 15.7998H36.8733C37.4866 15.7998 38.0382 15.4264 38.266 14.8569L37.8017 14.6712L38.266 14.8569L38.8088 13.4999C39.3403 12.1711 40.6273 11.2998 42.0584 11.2998H47.7003C48.5287 11.2998 49.2003 11.9714 49.2003 12.7998V26.4998C49.2003 28.9851 47.1856 30.9998 44.7003 30.9998H13.3003C10.815 30.9998 8.80029 28.9851 8.80029 26.4998V12.7998Z",
    fill: "#F9FAFB",
    stroke: "#E2E5E7"
  }))
};

var EmptyContent = function EmptyContent(_ref) {
  var message = _ref.message,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  var theme = useThemeProps();
  var style = useMemo(function () {
    return emptyContentStyle(theme);
  }, [theme]);
  var defaultIcon = theme.isSyetemThemeDark ? darkIcon[size] : lightIcon[size];
  var content = typeof message === 'function' ? message({
    icon: defaultIcon
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, defaultIcon, /*#__PURE__*/React.createElement("div", {
    className: label()
  }, message));
  var sizeClassName;

  switch (size) {
    case 'large':
      sizeClassName = large();
      break;

    case 'medium':
      sizeClassName = medium();
      break;

    case 'small':
      sizeClassName = small();
      break;

    default:
      break;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cx(prefix(), sizeClassName, columnCenter, style, className)
  }, content);
};

export default /*#__PURE__*/React.memo(EmptyContent);